import { FormattedMessage } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import {
  type BuyAndWinBenefit,
  BuyAndWinBenefitVariant,
  GIFT_APPLICATION,
  GiftKeys,
  MaxPriceKeys,
} from '../../../../typings'
import { messages } from '../messages'
import styles from './styles'

const benefitMessages = messages.buyAndWin.benefit

export function BuyAndWinRow(props: { benefit?: BuyAndWinBenefit }) {
  const { formatCurrency } = useNumbers()

  const { benefit } = props

  if (!benefit) return

  const renderDiscountDetails = () => {
    switch (benefit.type) {
      case BuyAndWinBenefitVariant.FREE_SHIPPING:
        return (
          <Tag>
            <FormattedMessage
              {...benefitMessages.freeShipping}
              values={{ tag: (content) => <Tag>{content}</Tag> }}
            />
          </Tag>
        )

      case BuyAndWinBenefitVariant.MAXIMUM_UNIT_PRICE_DISCOUNT:
        return (
          <FormattedMessage
            {...benefitMessages.maxPricePerItem}
            values={{
              tag: (content) => <Tag>{content}</Tag>,
              maxPrice: formatCurrency(benefit[MaxPriceKeys.price]),
            }}
          />
        )

      case BuyAndWinBenefitVariant.GIFT:
        return (
          <div className={styles.valueContentColumn}>
            <FormattedMessage
              tagName="div"
              {...benefitMessages.gift}
              values={{
                application: benefit[GiftKeys.application],
                tag: (content) => <Tag>{content}</Tag>,
              }}
            />
            <FormattedMessage
              tagName="div"
              {...benefitMessages.giftMaxQuantity}
              values={{
                quantity: benefit[GiftKeys.maxQuantity],
                tag: (content) => <Tag>{content}</Tag>,
              }}
            />
          </div>
        )
      default:
        return
    }
  }

  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage {...messages.discount.title} />
      </SummaryRow.Title>
      <SummaryRow.Value>{renderDiscountDetails()}</SummaryRow.Value>
    </SummaryRow>
  )
}
